import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {FormSection} from '@/components/commons/form-section/FormSection'
import {FormSectionLoader} from '@/components/commons/form-section/FormSectionLoader'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'

export const CompanyInfoFormLoader = () => {
    const {t} = useTranslation()

    return (
        <>
            <FormSection title={t('company_info:form:general_info_section_title')} hasBottomDivider>
                <Grid columns={2} gap={4}>
                    <GridItem spanColumn={2}>
                        <Skeleton height={56} />
                    </GridItem>
                    <GridItem>
                        <Skeleton height={56} />
                    </GridItem>
                    <GridItem>
                        <Skeleton height={56} />
                    </GridItem>
                </Grid>

                <Text render="h3" size="textMd" weight="500" style={{padding: '16px 0'}}>
                    {t('company_info:form:registered_office_label')}
                </Text>
                <Grid columns={6} gap={4}>
                    <GridItem spanColumn={2}>
                        <Skeleton height={56} />
                    </GridItem>
                    <GridItem spanColumn={2}>
                        <Skeleton height={56} />
                    </GridItem>
                    <GridItem>
                        <Skeleton height={56} />
                    </GridItem>
                    <GridItem>
                        <Skeleton height={56} />
                    </GridItem>
                </Grid>

                <Text render="h3" size="textMd" weight="500" style={{padding: '16px 0'}}>
                    {t('company_info:form:operative_address_label')}
                </Text>
                <GridItem>
                    <Skeleton height={24} width={200} />
                </GridItem>

                <Grid columns={2} gap={4} style={{marginTop: '16px'}}>
                    <GridItem>
                        <Skeleton height={56} />
                    </GridItem>
                    <GridItem>
                        <Skeleton height={56} />
                    </GridItem>
                    <GridItem>
                        <Skeleton height={56} />
                    </GridItem>
                </Grid>
            </FormSection>

            <FormSectionLoader />

            <FormSectionLoader />
        </>
    )
}
